<template lang="pug">
pr-wrapper.d-flex(fs, bg="darken", v-nv:scope="'chromecast'", nv-exit-protect, @nv-exit.native="close", @nv-back.native="close", @nv-up.native="state='watch'")
  .leftside.surface-bg.flex.flex-column(:class="{'surface-bg-darker': state === 'watch', 'surface-bg': state !== 'watch'}")
    .describe.flex-column(v-if="state === 'watch'")
      .ready-to-casting.display-4 You're ready to start casting
      .steps
        .step-item
          .title
            .number(v-visible="false")
            .name On your other device:
        .step-item
          .title
            .number 1
            .name Open your favorite media app
        .step-item
          .title
            .number 2
            .name
              | Tap Google Cast
              i.fab.fa-chromecast
        .step-item
          .title
            .number 3
            .name Select <b>Room 1001</b> in the list
      .cast-settings
        pr-button.button.background.mr-2(large v-nv.current @nv-enter="close") {{ $t("Done") }}
        pr-button.button.background(large v-nv @nv-enter="state='available'") {{ $t("Connect another device") }}
    .describe.flex-column(v-else)
      img.mockup(src="@/assets/images/chromecast/tv_phone_mockup.png")
      .room ROOM 1001
      .logo
        i.fab.fa-chromecast.fa-2xl.text-white
        span Google Cast
      .notification Connect your device to this TV to Cast anytime during your stay.  Your device stays connected until you check out.
      .legal By connecting, you agree to the Google Terms of Service. Google collects usage data and crash reports to help improve Cast. You can turn this off, as well as review the terms and Google Privacy Policy, in Cast settings.
      .cast-settings
        pr-button.primary-bg.button(large, v-nv.current @nv-enter="settings") {{ $t("Cast settings") }}

  .rightside.surface-bg-darker.flex.flex-column
    .describe(v-if="state === 'error'")
      .icon
        icon.display-1(:icon="'fas exclamation-triangle'") 
        .title.text-danger {{ $t("An error has occurred on the Chromecast server.") }}
        .subtitle {{ $t("Please contact technical service.") }}
        .subtitle(v-if="error") {{ error }}
    .describe(v-else-if="state === 'unavailable'")
      .icon
        icon.display-1(:icon="'fas frown'") 
        .title.text-danger {{ $t("Sorry, all chromecast devices are used by other guests.") }}
        .subtitle {{ $t("Please try again later.") }}
    .steps(v-else-if="state === 'available'")
      .step-item
        .title
          .number 1
          .name Connect your other device to Wi-Fi
        .content.primary-color
          i.fas.fa-wifi.fa-2xl(style="margin-right:10px;")
          span @{{ ssid || $t("Guest") }}
      .step-item
        .title
          .number 2
          .name Scan QR code or visit <b>{{ link || "cast.playroomtv.com" }}</b>
        .content.qrcode
          img.frame(src="@/assets/images/chromecast/qr_code_frame.png")
          img.qr(src="@/assets/images/chromecast/qrcode.png")
      .step-item
        .title
          .number 3
          .name Enter this PIN
        .content.primary-color
          span {{ code || $t("BAMNSV") }}
    .describe(v-else-if="state === 'watch'")
      img.confetti(src="@/assets/images/chromecast/chromecast_confetti.png")
      .tv-button.surface-bg-90.primary-color
        i.fal.fa-tv
        span ROOM 1001


</template>

<script>
export default {
  name: "chromecast-builtin",
  data() {
    return {
      guide: true,
      state: "available",
      error: null,
      interval: null,
      ssid: null,
      link: null,
      code: null,
      qrcode: null
    }
  },
  watch: {
    async state(nval, oval) {
      if (!oval) return
      await this.$nextTick()
      _$.nav.sync("chromecast", true)
    }
  },
  deactivated() {
    //this.reset()
    //__.api.get.castRemove()
    //_$.vue.$off("chromecast", this.checker)
  },
  async activated() {
    //_$.vue.$on("chromecast", this.checker)
    _$.nav.sync("chromecast", true)

    //this.reset()
    //this.checker()
  },

  async mounted() {
    _$.nav.sync("chromecast")

    webapis.googlecast.initialize()
    webapis.googlecast.acceptTermsOfService()
    webapis.googlecast.enableUsageReporting()
  },
  methods: {
    async checker() {
      const res = await __.api.get.castReservation()

      if (!res) this.state = "error"
      else if (res.error && res.status !== 200) {
        this.state = "error"
        this.error = res.error
      } else if (res.error) this.state = "unavailable"
      else if (res.heartbeat) this.watch()
      else {
        this.state = "available"
        this.ssid = res.ssid
        this.link = res.link
        this.code = res.reserv_code
        this.qrcode = res.qr_code
      }
    },
    async watch() {
      this.state = "watch"
      this.heartbeat()
    },
    heartbeat() {
      this.interval = _$.makeInterval(() => __.api.get.castHeartbeat(), 60000)
    },
    reset() {
      this.guide = true
      this.state = null
      this.error = null
      this.interval = this.interval ? _$.removeInterval(this.interval) : null
    },
    settings() {
      webapis.googlecast.launchSettings("")
    },
    close() {
      __.platform.go()
    }
  }
}
</script>

<style lang="scss" scoped>
.leftside {
  display: flex;
  flex: 1 0 0;
  padding: 50px 50px;

  .describe {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    padding: 0 30px;

    .ready-to-casting {
      font-weight: semibold;
    }
  }

  .steps {
    display: flex;
    flex-direction: column;
    margin: 40px 0;

    .step-item {
      display: flex;
      flex-direction: column;
      font-weight: semibold;

      .title {
        display: flex;
        align-items: center;
        font-size: 20px;
        margin-bottom: 20px;

        .number {
          height: 35px;
          width: 35px;
          line-height: normal;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          background: #333;
          margin-right: 10px;
        }
      }
    }
  }

  .mockup {
    width: 100%;
  }
  .room {
    margin: 20px 0 10px 0;
    opacity: 0.8;
    font-weight: semibold;
    font-size: 15px;
  }
  .logo {
    display: flex;
    align-items: center;
    font-size: 35px;

    span {
      font-size: 0.85em;
      white-space: nowrap;
      margin-left: 5px;
      font-weight: semibold;
      line-height: normal;
    }
  }
  .notification {
    margin: 10px 0;
    opacity: 0.8;
    font-size: 15px;
  }
  .legal {
    display: flex;
    align-items: flex-end;
    flex: 1 0 0;
    margin: 10px 0;
    opacity: 0.8;
    font-size: 15px;
    line-height: normal;
  }
  .cast-settings {
    margin-top: 15px;

    .button {
      border-radius: 20px;
    }
  }
}
.rightside {
  flex: 1 0 0;
  height: 100%;

  padding: 50px;

  .confetti {
    width: 100%;
  }

  .steps {
    display: flex;
    flex-direction: column;

    .step-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 50px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        display: flex;
        align-items: center;
        font-size: 25px;
        margin-bottom: 20px;

        .number {
          height: 35px;
          width: 35px;
          line-height: normal;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          background: #333;
          margin-right: 10px;
        }
      }

      .content {
        font-size: 25px;

        &.qrcode {
          width: 285px;
          height: 285px;
          border-radius: 25px;
          border: 4px solid #666;
          background: rgba(255, 255, 255, 0.01);
          position: relative;

          .frame {
            position: absolute;
            width: 90%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .qr {
            position: absolute;
            width: 85%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }

  .describe {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    .tv-button {
      margin: 20px auto;
      display: inline-block;
      border-radius: 20px;
      padding: 15px 20px;
      font-size: 15px;
      font-weight: bold;

      i {
        margin-right: 10px;
      }
    }
  }
}
</style>
